class Breadcrumbs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const dataBreadCrumbs = window.productBreadCrumbs
    const collections = dataBreadCrumbs.productCollections
    const menu = window.menuData
    const productTitle = dataBreadCrumbs.productTitle
    const previousPage = document.referrer

    function findBreadcrumbs(obj, targetLinks) {
      let path = [];
      let foundLinks = new Set(); // To track found links

      function recurse(items, currentPath) {
        // Sort items by priority before processing
        items.sort((a, b) => (a.priority || 0) - (b.priority || 0));

        for (const item of items) {
          const newPath = [...currentPath, { name: item.name, link: item.link }];
          if (targetLinks.includes(item.link) && !foundLinks.has(item.link)) {
            foundLinks.add(item.link);
            path = newPath;
            // If all links are found, stop searching
            if (foundLinks.size === targetLinks.length) return true;
          }
          if (item.child) {
            if (recurse(item.child, newPath)) {
              // Continue if path found in child
              if (foundLinks.size === targetLinks.length) return true;
            }
          }
        }
        return false; // Continue searching
      }

      // Check each top-level item
      for (const topLevelItem of obj) {
        if (recurse([topLevelItem], [])) {
          break; // Stop searching after finding all paths
        }
      }

      return path;
    }
    let breadcrumbTrail
    if (previousPage.includes('/collections/')) {
      let data = []
      const collectionUrl = previousPage.replace(window.location.origin, '')
      const collectionValue = collectionUrl.includes('?') ? collectionUrl.split('?')[0] : collectionUrl
      if (collections.includes(collectionValue)) data.push(collectionValue)
      breadcrumbTrail = findBreadcrumbs(menu, data).length > 0 ? findBreadcrumbs(menu, data) : findBreadcrumbs(menu, collections)
    } else if (dataBreadCrumbs.productMainCollection.find(Boolean).link) {
      breadcrumbTrail = dataBreadCrumbs.productMainCollection
    } else {
      breadcrumbTrail = findBreadcrumbs(menu, collections)
    }

    if(breadcrumbTrail.length < 1) breadcrumbTrail = dataBreadCrumbs.productMainCollection || dataBreadCrumbs.productDefaultCollection
    let html = breadcrumbTrail.map(item => `<a href="${item.link}">${item.name.toLowerCase()}</a>`).join('<span class="divider"></span>')
    html += `<span class="divider"></span><span>${productTitle}</span>`
    this.innerHTML = html
  }
}

customElements.define('product-breadcrumbs', Breadcrumbs);
